export default __webpack_public_path__ + "static/media/24.8d2ac90a.jpg";